import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { IBillingDetailsResponse } from "./index.type";

const useGetBillingCyclePdfPage = ({ billingId }: { billingId?: string }) => {
  const [billingDetails, setBillingDetails] =
    React.useState<IBillingDetailsResponse>();

  const { loading: getAllDetailsLoading, makeApiCall } = useApi({
    method: "GET",
    url: billingId
      ? `/rtm/summary-page/cron/pdf/billing-cycle/${billingId}`
      : "",
    preAuth: true,
  });

  const getBillingDetails = async () => {
    if (!billingId) return;

    const { response, error } = await makeApiCall<
      undefined,
      IBillingDetailsResponse
    >();

    if (response) {
      setBillingDetails(response);
    } else if (error) {
      toast.error("Something went wrong while fetching billing details");
      setBillingDetails(undefined);
    }
  };

  React.useEffect(() => {
    getBillingDetails();
  }, [billingId]);

  return { getBillingDetails, billingDetails, getAllDetailsLoading };
};

export default useGetBillingCyclePdfPage;
